/* eslint-disable react/prefer-stateless-function */
import dlv from 'dlv';
import { h, Component } from 'preact';
import {
	getRelatedProps,
	setLastGamePlayed
} from '../../../lib/game';
import { fetchArticleData } from '../../../lib/data';
import { getPageConfig } from '../../../lib/device';
import { getCommonProps, setTheme } from '../../../lib/page';
import style from './style';
import { Text } from 'preact-i18n';
// import { TaboolaJs } from '../../pieces/taboola-js';
import SimpleGridCluster from '../simple-grid-cluster';
import CardHeader from '../../pieces/card-header';
import { SadlibAd } from '../../pieces/sadlib-ad';
import cx from 'classnames';
import {
	TrackingProvider,
	DIMENSION,
	trackProps
} from '@cube/track';


export default class GameClusterP25 extends Component {
	getSequentialItem = (gameIDs) => {
		const dayNumber = new Date().getDay();
		const index = dayNumber % gameIDs.length;
		return gameIDs[index];
	};
	handleLoad = () => {
		this.setState({ iframeLoading: false });
	};
	//  TODO: last game played
	processPageInformation = (props) => {
		const gamesId = this.getSequentialItem(
			dlv(props.pageConfig, 'clusters.gamesCluster.gameId')
		);
		fetchArticleData({ article: gamesId, ...props })
			.then((res) => {
				if (!res || !dlv(res, 'embeds.0')) {
					return this.setState({ error: true, isLoading: false });
				}
				setLastGamePlayed(res);
				this.setState({ article: res });
			})
			.catch((err) => {
				this.setState({ error: true, isLoading: false });
			});
	};

	handleImageClick = () => {
		this.setState({ showIframe: true, iframeLoading: true });
	};

	getIframeStyles = (iframeStyle = {}) => ({
		width: '100%',
		...iframeStyle
	});

	componentWillMount() {
		let pageConfig = getPageConfig(this.props?.pageConfig, 'Desktop');
		this.setState({ pageConfig });
		setTheme(pageConfig);
		this.processPageInformation(this.props);
	}

	componentDidMount() {}

	render({ qeId, ...props }, { pageConfig, article, showIframe, iframeLoading }) {
		return (
			<TrackingProvider {...{ [DIMENSION.componentpath]: 'GamesCluster' }}>
				<div id={qeId} data-tb-region="GamesCluster">
					{/* {gamesConfig.title} */}
					<div class={style.gamesContainer}>
						<div class={style.gamesRow}>
							<div class={style.gamesMain}>
								<div class={style.gamesThumbnanail}>
									<CardHeader title="Todays Game"  qeId={qeId} />
									<TrackingProvider
										{...{ [DIMENSION.componentpath]: 'GamesPlay' }}
									>
										{!this.error ? (
											article && (
												<div class={style.iframeContainer}>
													{showIframe ? (
														<div>
															<iframe
																src={dlv(article, 'embeds.0.content')}
																style={this.getIframeStyles(
																	dlv(
																		pageConfig,
																		'clusters.gamesCluster.iframe.style'
																	)
																)}
																scrolling="no"
																allowFullScreen
																mozallowfullscreen="true"
																onLoad={this.handleLoad}
																webkitallowfullscreen="true"
															/>
															{iframeLoading && (
																<div class={style.loadingContainer}>
																	<img
																		src={dlv(article, 'images.0.src')}
																		alt="Click to open"
																		className={cx(
																			style.image,
																			style.fadeAnimation
																		)}
																		onClick={this.handleImageClick}
																		style={this.getIframeStyles(
																			dlv(
																				pageConfig,
																				'clusters.gamesCluster.iframe.style'
																			)
																		)}
																	/>
																</div>
															)}
														</div>
													) : (
														<div class={style.ImageContainer}>
															<img
																{...trackProps(
																	{
																		[DIMENSION.componentpath]: 'GameStart'
																	},
																	this.context
																)}
																src={dlv(article, 'images.0.src')}
																alt="Click to open"
																className={style.image}
																onClick={this.handleImageClick}
																style={this.getIframeStyles(
																	dlv(
																		pageConfig,
																		'clusters.gamesCluster.iframe.style'
																	)
																)}
															/>
														</div>
													)}

													<div class={style.details}>
														<div class={style.title}>{article.title}</div>
														<div class={style.summary}>{article.summary}</div>
													</div>
												</div>
											)
										) : (
											<div class={style.noGameError}>
												<div class={style.content}>
													<div class={style.message}>
														<Text id="gameNotAvailable" />
													</div>
													<img src="https://vam-image.imds-cdn.com/7b/cb/7bcb6df2e3f7d2dc442edcca97852399b55b1950" />
												</div>
											</div>
										)}
									</TrackingProvider>
								</div>

								<div class={style.gamesMore}>
									<CardHeader title="Find More Games" qeId={qeId} />
									<div class={style.gamePillsContainer}>
										{[
											...dlv(pageConfig, 'clusters.gamesCluster.moreSubNav')
										].map((type, i) => (
											<a
												{...trackProps(
													{
														[DIMENSION.componentpath]: 'GamesMore',
														[DIMENSION.text]: type.label
													},
													this.context
												)}
												href={type?.url}
											>
												<div class={style.gamePills}>{type?.label}</div>
											</a>
										))}
									</div>
								</div>
							</div>
							<div class={style.gamesAds}>
								{(article || this.error) && (
									<SimpleGridCluster
										{...getRelatedProps(article)}
										columnCount="1"
										rowCount="2"
										title="Similar Games"
										attributionOverride=""
										showDescription={false}
										showMore={false}
										hideAttribution
										imageOnly
										link={null}
										qeId="sc-game-landing"
										cardClass={style.similarGamesCard}
										ignoreId={dlv(article, 'metadata.canonical_id')}
										{...getCommonProps(props)}
									/>
								)}
								<SadlibAd
									id="home_p25_desktop_games_adContainer"
									type="desktopRail"
								/>
							</div>
						</div>
					</div>
				</div>
			</TrackingProvider>
		);
	}
}
